import React, { useState } from "react";
import CheckIcon from "@mui/icons-material/Check";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
interface IProps {
  cid?: string;
  time?: string;
  isSended?: boolean;
}
const CheckMark: React.FC<IProps> = ({ cid, time, isSended }) => {
  const { t } = useTranslation();
  const [copytext, setCopytext] = useState("");
  const copyToClipboard = (source: string) => {
    const copiedText = document.createElement("input");
    document.body.appendChild(copiedText);
    copiedText.setAttribute("value", source);
    copiedText.select();
    document.execCommand("copy");
    document.body.removeChild(copiedText);
  };
  const clickCopy = () => {
    copyToClipboard(cid);
    setCopytext(t("Message_Item_Copytext"));
    setTimeout(() => {
      setCopytext("");
    }, 1300);
  };
  const msgTime = new Date(time).toLocaleString("en-GB").slice(0, 17);
  return (
    <div>
      {isSended != undefined && isSended == false ? (<Tooltip
          title={t("CheckMark_Sending")}
          arrow
          disableInteractive
        >
          <CheckIcon
            style={{
              fontSize: "14px",
              marginRight: "5px",
              opacity: "0.5"
            }}
          />
        </Tooltip>) : !!cid ? (
        <Tooltip
          title={
            t("CheckMark_Uploaded_IPFS") + cid + ` (${msgTime})` + copytext
          }
          arrow
          disableInteractive
        >
          <span onClick={clickCopy}>
            <DoneAllIcon
              style={{
                fontSize: "14px",
                marginRight: "5px",
                cursor: "pointer",
              }}
            />
          </span>
        </Tooltip>
      ) : (
        <Tooltip
          title={t("CheckMark_Sent") + ` (${msgTime})`}
          arrow
          disableInteractive
        >
          <CheckIcon
            style={{
              fontSize: "14px",
              marginRight: "5px",
            }}
          />
        </Tooltip>
      )}
    </div>
  );
};
export default CheckMark;
